import { styled } from "@mui/material/styles";
import { HubHookFormSelectV2 } from "../HubHookFormSelectV2";

export const StyledHubHookFormSelect = styled(HubHookFormSelectV2)(
  ({ theme }) => ({
    "& .MuiInputBase-root ": {
      padding: "10px 15px !important",
      "& .MuiSvgIcon-root": {
        margin: "0px !important",
      },
      input: {
        backgroundColor: "transparent !important",
      },
    },
    "& .MuiSelect-select": {
      "& .MuiTypography-root": {
        fontWeight: 400,
        fontSize: "10px !important",
      },
    },
    "& .MuiChip-root": {
      display: "none",
    },
  })
);
